import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

import "../../styles/OnboardingModal.scss";
import Image from "react-bootstrap/Image";

const OnboardingModal = ({ show, onHide }) => {
    return (
        <Modal show={show} onHide={onHide} size="xl">
            <Modal.Header closeButton>
                <Row>
                    <Col xs={2}>
                        <Image src="/img/podsy-logo-w-200.png" fluid />
                    </Col>
                    <Col xs={10}>
                        <h2>Welcome to Podsy</h2>
                        <p className="mb-0">Podsy helps podcasts become conversations, not just episodes.</p>
                    </Col>
                </Row>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <Row className="mb-3">
                        <Col md={4}>
                            <Card className="h-100">
                                <Card.Img variant="top" src="/img/audience-wide.jpg" />
                                <Card.Body>
                                    <Card.Title>Discover Clubs</Card.Title>
                                    <Card.Text>
                                        Browse through public clubs or accept invitations to join private communities.
                                        Find topics that interest you and connect with like-minded listeners.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className="h-100">
                                <Card.Img variant="top" src="/img/microphone-wide.jpg" />
                                <Card.Body>
                                    <Card.Title>Listen to Discussions</Card.Title>
                                    <Card.Text>
                                        Access engaging podcast discussions from various clubs.
                                        Enjoy curated content and stay updated with the latest episodes.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className="h-100">
                                <Card.Img variant="top" src="/img/discussion-wide.jpg" />
                                <Card.Body>
                                    <Card.Title>Participate & Share</Card.Title>
                                    <Card.Text>
                                        Leave comments, share your thoughts, and engage with other listeners.
                                        Build connections within the community.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Row className="mb-2">
                        <Col md={4}>
                            <Card className="h-100">
                                <Card.Img variant="top" src="/img/person-wide.jpg" />
                                <Card.Body>
                                    <Card.Title>Manage Your Profile</Card.Title>
                                    <Card.Text>
                                        Customize your listener profile with your interests and preferences.
                                        Keep track of your favorite clubs and discussions.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className="h-100">
                                <Card.Img variant="top" src="/img/receiver-wide.jpg" />
                                <Card.Body>
                                    <Card.Title>Stay Notified</Card.Title>
                                    <Card.Text>
                                        Get notifications when new discussions are posted in your favorite clubs.
                                        Never miss out on content that matters to you.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className="h-100">
                                <Card.Img variant="top" src="/img/studio-wide.jpg" />
                                <Card.Body>
                                    <Card.Title>Support Creators</Card.Title>
                                    <Card.Text>
                                        Follow your favorite podcast creators and show your support.
                                        Engage with their content and help them grow their audience.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={onHide}>
                    Get Started
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default OnboardingModal;